import { Container } from 'pixi.js';

import { addToUI } from 'game/core/Playable2DRootContainer';

import gsap from 'gsap';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Layout } from 'game/LayoutManager';
import { Displays } from 'constants/layout';
import { UIButton } from './UIButton';
import { GAEvent, GAEventNames } from 'game/analytics/events';
import { Store } from 'game/store/gameStore';
import { Popups } from 'ui/types/popups';
import { GameUI } from './GameUI';
import { getScreenSize } from 'game/core/screen';

export class TutorialUI extends MonoBehavior {
    container: Container;
    buttons: UIButton[] = [];

    constructor() {
        super();
        this.skipTutorial = this.skipTutorial.bind(this);
        this.restartTutorial = this.restartTutorial.bind(this);
        this.container = new Container();
        this.container.zIndex = 3000; // Above tutorial overlay (2000)
        if (!Store.inArticle) {
            const skipButton = new UIButton('tutorialSkip', this.skipTutorial);
            this.buttons.push(skipButton);
            this.container.addChild(skipButton.container);
        }
        const restartButton = new UIButton('tutorialRestart', this.restartTutorial);
        this.buttons.push(restartButton);
        this.container.addChild(restartButton.container);
        addToUI(this.container);
        this.container.visible = false;
    }

    start() {
        const { width, height } = getScreenSize();
        this.resize(width, height);
    }

    skipTutorial() {
        GameUI.showPopup(Popups.TUTORIAL_SKIP);
        GAEvent(GAEventNames.TUTORIAL_SKIP_BTN_CLICK, {
            step: Store.tutorialStep,
            placement: Store.tutorialPlacement,
        });
        GAEvent(GAEventNames.TUTORIAL_SKIP_POPUP, {
            step: Store.tutorialStep,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        });
    }
    restartTutorial() {
        if (import.meta.url.includes('localhost:5173')) {
            console.warn("%cREMOVE THIS LINE - it's for testing purposes only", 'color: red; font-weight: bold;');
            dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_restart', confirm: true } }));
        } else {
            GAEvent(GAEventNames.TUTORIAL_RESTART_BTN_CLICK, {
                step: Store.tutorialStep,
                placement: Store.tutorialPlacement,
            });
            GameUI.showPopup(Popups.TUTORIAL_RESTART);

            GAEvent(GAEventNames.TUTORIAL_RESTART_POPUP, {
                step: Store.tutorialStep,
                type: Store.getGameTypeText(),
                difficulty: Store.getDifficultyText(),
                placement: Store.tutorialPlacement,
            });
        }
    }

    resize(width: number, height: number) {
        const buttonsWidth = [] as number[];
        this.buttons.forEach((button) => {
            button.adjustFontSizeByDevice();
            buttonsWidth.push(button.container.width);
        });
        let mobileMargin = 0;
        this.buttons.forEach((button, index) => {
            switch (Layout.getDisplay()) {
                case Displays.DESKTOP:
                    button.container.x = width - 25 - Math.max(...buttonsWidth) / 2;
                    button.container.y = 40 + index * 62;
                    break;
                case Displays.TABLET:
                    button.container.x = width - 30 - mobileMargin;
                    button.container.y = 19;
                    mobileMargin += button.container.width + 36;
                    break;
                case Displays.MOBILE:
                    button.container.x = width - 8 - mobileMargin;
                    button.container.y = 19;
                    mobileMargin += button.container.width + 36;
                    break;
            }
        });
    }

    show() {
        this.container.alpha = 0;
        this.container.visible = true;
        gsap.to(this.container, { alpha: 1, duration: 0.3 });
    }
    hide() {
        gsap.to(this.container, {
            alpha: 0,
            duration: 0.3,
            onComplete: () => {
                this.container.visible = false;
            },
        });
    }
}
